<template>
  <p class="ta-confirmation-message">
    {{ message }}
  </p>
</template>

<script>
export default {
  name: "ConfirmationMessage",
  props: {
    message: {
      type: String,
      default() {
        return this.$t('Are you sure you want to buy this item?');
      }
    }
  }
}
</script>

<style scoped>

</style>
